<script setup>
import { onUnmounted } from 'vue'
import "@/components/accessibility/accessibility.js";

onUnmounted(() => {
  console.log('About Page is being destroyed — user navigated away')
  // cleanup timers, save state, close sockets, etc.
})
</script>

<template>
	<router-view />
</template>